import axios from 'axios'
import { call, put } from 'redux-saga/effects'
import { API } from 'constants/apiRouting'
import NoticeHelper from './notice'
import ProfileHelper from './profile'
import { SHOW_NOTICE } from '../reducers/notice'
import { RESET_STORE } from '../constants'
import { SET_ACCESS_DENIED } from '../reducers/layout/reducer'
import { SET_MAINTENANCE_MODE } from '../reducers/maintenance/reducer'

/**
 *
 * @param payload -
 * @param responseOptions - array of keys that will has axios response
 * @returns {
 * Generator<PutEffect<{type: string, notice: *}>
 * CallEffect|PutEffect<{type: string}>, {error: boolean, errors: string}|any|number, *>}
 */

const recoveryPasswordRedirect = ({
  user_must_change_password,
  change_password_url,
} = {}) => {
  if (user_must_change_password) {
    ProfileHelper.removeToken()
    window.location.replace(change_password_url)
  }
}

const stringifyResponseError = ({ data: { errors, message } } = {}) => {
  if (errors) {
    if (typeof errors === 'object') {
      return errors
    }

    let errorString = ''

    errors.forEach(error => {
      errorString += `${error.field} - ${error.message} `
    })

    return errorString
  }

  return message
}

function* fetchFromAPI(payload, responseOptions = ['data']) {
  try {
    const res = yield call(axios, `${API}${payload.partUrl}`, payload)
    const { status, data } = res

    if (status === 204) {
      return 204
    }

    if (Array.isArray(responseOptions) && responseOptions.length) {
      if (data) {
        recoveryPasswordRedirect(data)
      }

      if (responseOptions.length > 1) {
        return responseOptions.reduce((response, key) => {
          // eslint-disable-next-line no-param-reassign
          response[key] = res[key]

          return response
        }, {})
      }

      return res[responseOptions.shift()]
    }

    recoveryPasswordRedirect(data)

    return data
  } catch (error) {
    const { response } = error

    if (!response) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('Server not responding'),
      })

      return {
        error: true,
        errors: error.toString(),
      }
    }

    if (response.status === 503) {
      yield put({ type: SET_MAINTENANCE_MODE, payload: true })

      return {
        error: true,
        errors: response.data,
        status: response.status,
        ...response.data,
      }
    }

    if (response.status === 500) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(response.data.message),
      })
    } else if (response.status === 400) {
      let { message } = response.data
      const {
        errors: { email },
      } = response.data

      if (email) {
        message += `: ${email}`
      }

      if (message !== 'Validation failed') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(message),
        })
      }
    } else if (
      response.status === 401 &&
      response.data.message === 'Expired JWT Token'
    ) {
      yield put({ type: RESET_STORE })
    } else if (response.status === 403) {
      yield put({ type: SET_ACCESS_DENIED, payload: true })
    }

    return {
      error,
      errors: stringifyResponseError(response),
      status: response.status,
      ...response.data,
    }
  }
}

export const getDefaultHeaders = (customHeaders = {}) => ({
  'Content-Type': 'application/json',
  ...customHeaders,
})

export const getDefaultAutorizedHeaders = (customHeaders = {}) => {
  const token = `Bearer ${localStorage.getItem('token')}`

  return {
    Authorization: token,
    ...getDefaultHeaders(customHeaders),
  }
}

export const toFormData = data => {
  const formData = new FormData()
  Object.keys(data).forEach(field => {
    const value = data[field]

    if (Array.isArray(value)) {
      value.forEach(valuePart => {
        formData.append(`${field}[]`, valuePart)
      })
    } else {
      formData.append(field, value)
    }
  })

  return formData
}

export default fetchFromAPI
